import Vue from 'vue';
import ProgressBar from './components/ProgressBar';

export const prefetchMixin = {
  beforeRouteUpdate (to, from, next) {
    if (this.$options.prefetch) {
      this.$options.prefetch({ store: this.$store, to, from, router: this.$router })
        .then(next, next);
    } else {
      next();
    }
  },
};

export function clientSetup ({ router, store }) {
  const bar = new Vue(ProgressBar).$mount();
  Vue.prototype.$bar = bar;
  document.body.appendChild(bar.$el);

  // Add router hook for handling prefetch.
  // Doing it after initial route is resolved so that we don't double-fetch
  // the data that we already have. Using router.beforeResolve() so that all
  // async components are resolved.
  router.beforeResolve((to, from, next) => {
    const matched = router.getMatchedComponents(to);
    const prevMatched = router.getMatchedComponents(from);
    let diffed = false;
    const activated = matched.filter((c, i) => {
      // eslint-disable-next-line no-return-assign
      return diffed || (diffed = (prevMatched[i] !== c));
    });
    const prefetchHooks = activated.map(c => c.prefetch).filter(_ => _);
    if (!prefetchHooks.length) {
      return next();
    }

    bar.start();
    Promise.all(prefetchHooks.map(hook => hook({ store, to, from, router })))
      .then(() => {
        bar.finish();
        next();
      })
      .catch((e) => {
        bar.finish();
        next(e);
      });
  });
}

export const prefetchSetup = clientSetup;
